import { toast } from "react-toastify";
import React, { useEffect } from "react";
import { ProductController } from "../../../../core/config/controllers/ProductController";
import ModalComponent from "../../../../core/layouts/main/components/Modal";
import Field from "../../../../core/layouts/main/components/Field";
import { FieldHelper } from "../../../../core/config/helpers/FieldHelper";
import { FileController } from "../../../../core/config/controllers/FileController";
import { CategoryController } from "../../../../core/config/controllers/CategoryController";

export default function ProductModal({ show, onHide, infos }) {
    const [data, setData] = React.useState(infos);
    const [categories, setCategories] = React.useState([]);

    useEffect(() => {
        if (infos && infos.id) {
            console.log("Loading product data:", infos);
            setData(infos);
        } else {
            setData({});
        }
        if(show){
            loadCategories();
        }
    }, [infos, show]);

    function loadCategories() {
        CategoryController.List((result) => {
            setCategories(result);
        });
    }

    async function save() {

        if (data.id) {
            await ProductController.Update(data)
            toast.success("Taxa atualizada com sucesso!");
            onHide();
        } else {
            ProductController.Insert(data, (res) => {
                toast.success("Taxa criada com sucesso!");
                onHide();
            })
        }

    }

    function handleChange(e, type) {
        setData(FieldHelper.OnDataChange(data, e, type));
    }

    function uploadImages(files) {
        const timestamp = Date.now();
        FileController.UploadFile(`cms_uploads/products/${timestamp}`, files[0])
            .then((url) => {
            setData({
                ...data,
                images: [...(data.images || []), url]
            });
            })
            .catch((error) => {
            console.error("Error uploading image:", error);
            toast.error("Erro ao fazer upload da imagem");
            });
    }

    return (
        <ModalComponent
            show={show}
            title={"Produto"}
            onHide={() => onHide()}
            onSubmit={() => save()}>

            {Array.isArray(data.images) && data.images.length > 0 && (
                <div style={{ marginBottom: 16 }}>
                    <div style={{ marginBottom: 8, fontWeight: "bold" }}>Imagens</div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 12 }}>
                        {data.images.map((img, idx) => (
                            <div key={idx} style={{ position: "relative", display: "inline-block" }}>
                                <img
                                    src={img}
                                    alt={`Imagem ${idx + 1}`}
                                    style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 4, border: "1px solid #eee" }}
                                />
                                <button
                                    type="button"
                                    onClick={() => {
                                        if(window.confirm("Tem certeza que deseja excluir esta imagem?")) {
                                            const newImages = data.images.filter((_, i) => i !== idx);
                                            setData({ ...data, images: newImages });
                                        }
                                    }}
                                    style={{
                                        position: "absolute",
                                        top: 2,
                                        right: 2,
                                        background: "#fff",
                                        border: "1px solid #ccc",
                                        borderRadius: "50%",
                                        width: 22,
                                        height: 22,
                                        cursor: "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        padding: 0,
                                    }}
                                    aria-label="Excluir imagem"
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            <div className="form-group">
                <span>Fazer upload das fotos</span>
                <input type="file" className="form-control" accept="image/*" multiple
                    onChange={(e) => uploadImages(e.target.files)} />
            </div>

            <Field title="Nome" name={"name"} value={data.name} onChange={(e) => handleChange(e)} />
            <Field title="Descrição" name={"description"} value={data.description} type={FieldHelper.FieldTypeObj.TextArea} onChange={(e) => handleChange(e)} />
            <Field title="Preço" name={"price"} value={data.price} type={FieldHelper.FieldTypeObj.Number} onChange={(e) => handleChange(e)} />
            <Field title="Em estoque" name={"stock"} value={data.stock} type={FieldHelper.FieldTypeObj.Number} onChange={(e) => handleChange(e)} />

            <div className="form-group">
                <label>Categorias</label>
                <br/>
                {categories.map((category) => (
                    <label key={category.id} style={{ display: "block", marginBottom: 4 }}>
                        <input
                            type="checkbox"
                            checked={Array.isArray(data.categories) && data.categories.filter(x => x.id === category.id)}
                            name={`category-${category.id}`}
                            onChange={(e) => {
                                const checked = e.target.checked;
                                let updatedCategories = Array.isArray(data.categories) ? [...data.categories] : [];
                                if (checked) {
                                    if (!updatedCategories.includes(category.id)) {
                                        updatedCategories.push(category.id);
                                    }
                                } else {
                                    updatedCategories = updatedCategories.filter(id => id.id !== category.id);
                                }
                                setData({ ...data, categories: updatedCategories });
                            }}
                        />
                        {category.name}
                    </label>
                ))}
            </div>

        </ModalComponent>
    )
}